import { fetchData } from './fetchData';
import { Product } from '../data/Product';

export type ProductProgressRequestData = {
    barcode: string,
    sn_code: string,
    product_model_id: string,
    location:string,
    line_uid: string,
    login: string,
};

type ProductProgressResponseData = Product[];

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function productProgress(data: ProductProgressRequestData): Promise<Product[]> {
    return fetchData('api/product_contract', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: ProductProgressResponseData) => resData);
}

export { productProgress };
